import { render } from "./LitStep2.vue?vue&type=template&id=020dc040&scoped=true"
import script from "./LitStep2.vue?vue&type=script&lang=js"
export * from "./LitStep2.vue?vue&type=script&lang=js"

import "../form.css?vue&type=style&index=0&id=020dc040&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020dc040"]])

export default __exports__